import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface FieldsContainerProps {
    extendedSearchAuthorized?: boolean;
}

const getMediaQueries = (extendedSearchAuthorized: boolean | undefined) => {
    if (extendedSearchAuthorized) {
        return {
            // 1800px and below
            '@media (max-width: 1800px)': {
                gridTemplateColumns: 'repeat(7, 1fr)',
                gridTemplateAreas: `'startDate endDate customerId endpoint manifestNumber partNumber parcelCode'
                                    'buttons buttons buttons buttons buttons buttons buttons'`,
            },

            // 1700px and below
            '@media (max-width: 1700px)': {
                gridTemplateColumns: 'repeat(6, 1fr)',
                gridTemplateAreas: `'startDate endDate customerId endpoint manifestNumber parcelCode'
                                    'partNumber buttons buttons buttons buttons buttons'`,
            },

            // 1600px and below
            '@media (max-width: 1600px)': {
                gridTemplateColumns: 'repeat(5, 1fr)',
                gridTemplateAreas: `'startDate endDate customerId endpoint parcelCode'
                                    'manifestNumber partNumber buttons buttons buttons'`,
            },

            // 1300px and below
            '@media (max-width: 1300px)': {
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridTemplateAreas: `'startDate endDate customerId parcelCode'
                                    'endpoint manifestNumber partNumber buttons'`,
            },

            // 1100px and below
            '@media (max-width: 1100px)': {
                gridTemplateColumns: 'repeat(3, 1fr)',
                gridTemplateAreas: `'startDate endDate parcelCode'
                                    'customerId endpoint manifestNumber'
                                    'partNumber buttons buttons'`,
            },

            // 900px and below
            '@media (max-width: 900px)': {
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateAreas: `'customerId parcelCode'
                                    'startDate endDate'
                                    'endpoint manifestNumber'
                                    'partNumber buttons'`,
            },

            // 700px and below
            '@media (max-width: 700px)': {
                gridTemplateColumns: '1fr',
                gridTemplateAreas: `'parcelCode'
                                    'startDate'
                                    'endDate'
                                    'customerId'
                                    'endpoint'
                                    'manifestNumber'
                                    'partNumber'
                                    'buttons'`,
            },
        };
    } else {
        return {
            // 1300px and below
            '@media (max-width: 1300px)': {
                gridTemplateColumns: 'repeat(3, 1fr)',
                gridTemplateAreas: `'startDate endDate parcelCode'
                                    'manifestNumber buttons buttons'`,
            },

            // 1000px and below
            '@media (max-width: 1000px)': {
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateAreas: `'manifestNumber parcelCode'
                                    'startDate endDate'
                                    'buttons buttons'`,
            },

            // 700px and below
            '@media (max-width: 700px)': {
                gridTemplateColumns: '1fr',
                gridTemplateAreas: `'parcelCode'
                                    'startDate'
                                    'endDate'
                                    'manifestNumber'
                                    'buttons'`,
            },
        };
    }
};

export const FieldsContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'extendedSearchAuthorized',
})<FieldsContainerProps>(({ extendedSearchAuthorized }) => ({
    display: 'grid',
    gridTemplateColumns: extendedSearchAuthorized ? 'repeat(8, 1fr)' : 'repeat(5, 1fr)',
    gridTemplateAreas: extendedSearchAuthorized
        ? '"startDate endDate customerId endpoint manifestNumber partNumber parcelCode buttons"'
        : '"startDate endDate manifestNumber parcelCode buttons"',
    gap: '1rem',

    '#customerId-field': {
        gridArea: 'customerId',
    },
    '#startDate-field': {
        gridArea: 'startDate',
    },
    '#endDate-field': {
        gridArea: 'endDate',
    },
    '#endpoint-field': {
        gridArea: 'endpoint',
    },
    '#manifestNumber-field': {
        gridArea: 'manifestNumber',
    },
    '#partNumber-field': {
        gridArea: 'partNumber',
    },
    '#parcelCode-field': {
        gridArea: 'parcelCode',
    },
    '#buttons-container': {
        gridArea: 'buttons',
    },

    ...getMediaQueries(extendedSearchAuthorized),
}));
